import Vue from "vue";
import TitleMixin from "@/mixins/title";
import SpinnerMixin from "@/mixins/spinner";
import { mapGetters } from "vuex";
export default Vue.extend({
    mixins: [TitleMixin, SpinnerMixin],
    data() {
        return {
            title: this.$t("rooms.edit.title"),
            id: this.$route.params.id,
            room: {},
            offices: [],
            validationOptions: {
                rules: {
                    officeId: {
                        required: true
                    },
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    capacity: {
                        required: true,
                        number: true,
                        min: 0
                    }
                }
            }
        };
    },
    computed: {
        ...mapGetters({
            hasMultipleOffices: "account/hasMultipleOffices"
        })
    },
    methods: {
        edit() {
            return this.$store.dispatch("room/edit", {
                id: this.id,
                room: this.room
            });
        },
        editSuccess() {
            this.$toast.showSuccessToast(this.$t("rooms.edit.toastSuccessTitle"), this.$t("rooms.edit.toastSuccessContent", {
                name: this.room.name
            }));
            return this.$router.push("/administration/rooms");
        },
        cancel() {
            return this.$router.push("/administration/rooms");
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            this.offices = await this.$store.dispatch("office/getAll");
            this.room = await this.$store.dispatch("room/get", {
                id: this.id
            });
            this.title += ` ${this.room.name}`;
        }
        catch (errors) {
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/administration/rooms");
        }
        finally {
            this.hideSpinner();
        }
    }
});
